<template>
  <div class="col-md-12 col-sm-12">
    <div class="row">
      <div class="col-10">
        <h5 class="d-inline">
          CUSTOM INDICATORS
        </h5>
        <p class="m-t-0">
          Custom Indicators, which are added by auditor
        </p>
      </div>
      <div v-if="activeGroup && (activeGroup.anonymous_account === auditor)" class="col-2 text-right">
        <button data-target="#addModal" data-toggle="modal" data-whatever="@getbootstrap" class="btn btn-sm btn-info">
          <i class="fa fa-plus" /> Add Indicator
        </button>
      </div>
    </div>
    <template v-if="indicators.length>0">
      <template v-for="indicator in indicators">
        <indicator :key="indicator.control_point_id" :id="indicator.control_point_id" :status="auditStatus" :auditId="auditId" :auditor="auditor" :name="indicator.control_point_name" :indicator="indicator" />
      </template>
    </template>
    <div v-else class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header text-center">
            <h4>There are no Custom Indicators added yet.</h4>
          </div>
        </div>
      </div>
    </div>
    <add-indicator :audit-id="auditId" />
  </div>
</template>

<script>
import Indicator from './Indicator.vue';
import AddIndicator from './AddIndicator.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'CustomTemplate',
  components: { Indicator, AddIndicator },
  props: ['auditId', 'custom', 'events', 'auditStatus', 'auditor'],
  data() {
    return {
      impactArea: 'CUSTOM',
      showCustom: false,
      indicators: []
    };
  },
  computed: {
    ...mapGetters(['currentUser', 'activeGroup'])
  },
  mounted() {
    this.getCustomControlPoints();
  },
  methods: {
    async getCustomControlPoints() {
      try {
        this.indicators = (await this.$api.get(`/audits/${this.auditId}/custom_control_points`)).data;
        console.log(this.indicators);
      } catch (e) {
        console.error(e);
      }
    }
  }
}
</script>

<style scoped>
</style>
